import { render, staticRenderFns } from "./roleFields2.vue?vue&type=template&id=1a15e643&scoped=true"
import script from "./roleFields2.vue?vue&type=script&lang=js"
export * from "./roleFields2.vue?vue&type=script&lang=js"
import style0 from "./roleFields2.vue?vue&type=style&index=0&id=1a15e643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15e643",
  null
  
)

export default component.exports